import React from "react";
import "./home.css";
import img from "assets/home/PHOTO.png";
import citi from "assets/home/citi.png";
import fisio from "assets/home/fisio.png";
import team from "assets/home/team.png";
import Button from "../../components/button/Button";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  const contactMeHandler = () => {
    navigate('/contact');
  };

  const showPortofolio = () => {
    navigate('/portofolio');
  } 

  return (
    <div className="container-xxl">
      <div className="main-div">
        <img src={img} alt="avatar" className="avatar"></img>
        <h1 className="avatar-text">Building digital products, brands and experience.</h1>
        <Button
          text="Contact me"
          onClickHandler={contactMeHandler}
          icon="bi bi-chat-heart" ></Button>
      </div>
      <div className="services d-flex flex-column flex-sm-column flex-md-row">
        <div className="service-container">
          <h2 className="league-spartan-title">UI & UX Design</h2>
          <p className="service-short-description">
          Our UI/UX design service focuses on creating user-centric, visually stunning, and seamless digital experiences. We combine creativity and strategy to design interfaces that not only look amazing but also function flawlessly. From wireframing and prototyping to crafting responsive layouts and interactive designs, we ensure every detail enhances usability. Our goal is to deliver designs that captivate your audience, improve user engagement, and boost customer satisfaction. Whether you need mobile app interfaces or website designs, we bring your vision to life with a perfect balance of aesthetics and functionality.
          </p>
        </div>
        <div className="service-container">
          <h2 className="league-spartan-title">Web App Development</h2>
          <p className="service-short-description">
          Our web development service delivers high-performance, responsive, and scalable websites tailored to meet your business needs. From dynamic front-end interfaces to robust back-end systems, we build websites that are secure, fast, and optimized for all devices. Using the latest technologies and best practices, we turn your ideas into functional, user-friendly digital platforms. Whether you need an e-commerce site, a corporate website, or a custom web application, we ensure your online presence is professional, modern, and aligned with your goals. Let us help you create a powerful and impactful digital footprint!
          </p>
        </div>
      </div>
      <div className="portofolio">
        <h2 className="pb-3">Recent Client Works</h2>
        <div className="portofolio-carousel">
          <ul className="portofolio-works-image">
            <li><img src={citi} alt='citi' className="portofolio-image"/></li>
            <li><img src={fisio} alt='citi' className="portofolio-image" /></li>
            <li><img src={team} alt='citi' className="portofolio-image" /></li>
          </ul>
          <button className="view-more" onClick={showPortofolio}>View More</button>
        </div>
      </div>
    </div>
  );
}
export default Home;
